module.exports = __webpack_public_path__ + "assets/qrcode.e1805cb2.svg";